// The Security page's section ids: the nav's targets and the cards' ids.

export const SECURITY_SECTION = {
    keys: "section-keys",
    key: (keyId: string) => `section-key-${keyId}`,
    newKey: "section-new-key",
    enforcement: "section-enforcement",
    history: "section-history",
} as const;
